import { User } from '@xq/domain';

const createdAt = new Date().toISOString();
const modifiedAt = new Date().toISOString();

export const students: Partial<User>[] = [
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'e2e_test_student@xqlabsdev.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'deyan.student@xqlabs.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'anton.student@xqlabs.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'anton.student@xqlabsdev.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
];

const testStudentEmails = [
  'e2e_test_student@xqlabsdev.io',
  'deyan.student@xqlabs.io',
  'anton.student@xqlabs.io',
  'anton.student@xqlabsdev.io',
] as const;

export type TestStudentEmail = (typeof testStudentEmails)[number];

export const TEST_STUDENT_EMAILS = testStudentEmails.reduce(
  (acc, email) => ({
    ...acc,
    [email]: email,
  }),
  {} as Record<TestStudentEmail, TestStudentEmail>
);

// TODO - ADD
// stage.student.1@xqlabs.io
// stage.student.2@xqlabs.io
// stage.student.4@xqlabs.io
// stage.student.5@xqlabs.io
// stage.student.6@xqlabs.io
// stage.student.7@xqlabs.io
// stage.student.8@xqlabs.io
